import { render, staticRenderFns } from "./orderInvestigate.vue?vue&type=template&id=432d875c&scoped=true&"
import script from "./orderInvestigate.vue?vue&type=script&lang=js&"
export * from "./orderInvestigate.vue?vue&type=script&lang=js&"
import style0 from "./orderInvestigate.vue?vue&type=style&index=0&id=432d875c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432d875c",
  null
  
)

export default component.exports